import { saved_surveysId } from "../../types/saved_surveys";
import SavedSurvey from "../components/SurveyResultsTab/SurveyResultsTab.type";
import supabase from "./supabase";

/**
 * Get a survey response based on a survey ID.
 * @param {number} surveyId The ID of the survey which responses we are trying to get.
 */
const fetchSurveyResponses = async (surveyId: saved_surveysId) => {
  const { data, error } = await supabase
    .from("survey_responses")
    .select("*, slack_users (slack_id, name)")
    .filter("survey_id", "eq", surveyId);
  if (error) console.log("error", error);
  return data;
};

export { fetchSurveyResponses };

/**
 * Get the list of saved surveys ordered desc by created date
 */
const fetchSavedSurveys = async (teamId: string) => {
  const { data, error } = await supabase
    .from<SavedSurvey>("saved_surveys")
    .select("*")
    .filter("team", "eq", teamId)
    .order("created_at", { ascending: false });
  if (error) console.log("error", error);
  return data;
};

export { fetchSavedSurveys };
